import { render, staticRenderFns } from "./Panier.vue?vue&type=template&id=21b55a94&scoped=true&"
import script from "./Panier.vue?vue&type=script&lang=js&"
export * from "./Panier.vue?vue&type=script&lang=js&"
import style0 from "./Panier.vue?vue&type=style&index=0&id=21b55a94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b55a94",
  null
  
)

export default component.exports